import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Subject } from 'rxjs';
import { AlertsComponent } from '../../alerts/components/alerts.component';
import { ActionBase } from '../../../core/store/action/ActionBase';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'plr-action-loading',
  templateUrl: './action-loading.component.html',
  styleUrls: ['./action-loading.component.scss']
})
export class ActionLoadingComponent implements OnInit {
  isLoading: boolean;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  destroyed: boolean;
  subscription: ISubscription = undefined;

  @Input()
  action: string;

  @Input()
  actionSuccess: string;

  @Input()
  actionId: string;

  @Input()
  alerts: AlertsComponent;

  @Input()
  successMessage: string = "Success";

  @Input()
  diameter: number = 30;

  constructor(private actions$: Actions) {
    this.isLoading = false;
   }

  ngOnInit() {
    this.actions$.ofType(this.action)
      .takeUntil(this.destroyed$)
      .subscribe((a: ActionBase) => {
        if(!this.actionId || a.identifier === this.actionId) {
          this.isLoading = true;
        }
      });
      this.subscription = this.actions$.ofType(this.actionSuccess)
        .subscribe((a: any) => {
          if(!this.actionId || !a.action || a.action.identifier === this.actionId) {
            this.isLoading = false;            
            this.alerts.addSuccess(this.successMessage);
          }
          if(this.destroyed){
            this.subscription.unsubscribe();
            this.subscription = undefined;
          }
        });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed = true;
    setTimeout(()=> {
      if(this.subscription){
        this.subscription.unsubscribe();
      }
    }, 100)
  }

}



// WEBPACK FOOTER //
// ./src/app/pillar/common/components/action-loading.component.ts